import * as errorReporter from 'app/errorReporter';
import backend from 'app/backend';
import { dispatch } from 'app/store';
import GetShopInfo from './GetShopInfo';
import NotifyUser from './NotifyUser';
type Options = {
  notifyUser?: boolean;
};
const defaultOptions = {
  notifyUser: true,
};
export default function SignOut(options: Options = {}) {
  options = Object.assign({}, defaultOptions, options);
  backend.abortSessionUserDependentRequests();
  dispatch({
    type: 'SIGN_OUT_START',
  });
  backend
    .dispatch('LogOutUser')
    .then(() => {
      dispatch({
        type: 'SIGN_OUT_SUCCESS',
      });
      errorReporter.setContext({
        userEmail: null,
        user: null,
      });
    })
    .then(() => {
      if (options.notifyUser) {
        NotifyUser({
          message: 'You have been signed out.',
          timeoutMs: 6000,
        });
      }
      GetShopInfo({
        forceRefresh: true,
      });
    });
}
